
import { useStore } from "vuex";
export default function
    useVFAuth( ) {
    const store = useStore();

    const onRefreshToken = async ( refreshToken ) => {
        try {
            const response = await store.dispatch('auth/refreshToken', { refresh_token: refreshToken });
            return response;
        } catch (error) {
            return { ok: false, message: 'Error al refrescar token' };
        }
    }

    return {
        onRefreshToken
    }
}